import React from "react";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { SITE_DASHBOARD_PATH, SITE_NAV_ROUTES } from "../../../constants/siteNavRoutes";
import { trackHomepageCtaClick } from "../../../utils/analytics";

const HomeRpgFinalCta = () => {
  return (
    <section className="td-rpg-final" aria-labelledby="td-final-heading">
      <h2 id="td-final-heading">JOIN THE WAR FOR OSHAR</h2>
      <p>
        Sign in with Treydora, link a wallet from the Gateway dashboard, and secure Treydorex &amp; Koraxos collectibles
        for the next age of the realm.
      </p>
      <div className="td-rpg-final__row">
        <Link
          to={SITE_DASHBOARD_PATH}
          className="td-btn-gold td-rpg-final__cta-secondary"
          onClick={() =>
            trackHomepageCtaClick({
              cta_id: "final_login_or_connect_wallet",
              section: "final_cta",
              destination: SITE_DASHBOARD_PATH,
            })
          }
        >
          Login or connect wallet
        </Link>
        <HashLink
          smooth
          to={SITE_NAV_ROUTES.TOKEN_SALE}
          className="td-btn-gold"
          onClick={() =>
            trackHomepageCtaClick({
              cta_id: "final_buy_treydorex",
              section: "final_cta",
              destination: SITE_NAV_ROUTES.TOKEN_SALE,
            })
          }
        >
          BUY TREYDOREX
        </HashLink>
      </div>
    </section>
  );
};

export default HomeRpgFinalCta;
